import { render } from "./OdontogramInput.vue?vue&type=template&id=0fa2c4dc&scoped=true"
import script from "./OdontogramInput.vue?vue&type=script&lang=js"
export * from "./OdontogramInput.vue?vue&type=script&lang=js"

import "./OdontogramInput.vue?vue&type=style&index=0&id=0fa2c4dc&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fa2c4dc"]])

export default __exports__